import { Grid } from '@material-ui/core';
import { SinglePaymentCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../shared/components/Text';

export const customerFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.38,
    field: 'customer',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'CLIENT'} />,
    renderCell: (rowData: { row: SinglePaymentCriteria }) => {
      return (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'break-spaces',
              lineHeight: '1.43',
              width: '100%',
            }}
          >
            <Grid container alignItems={'center'}>
              <Grid item xs={12}>
                <div className={'line-clamp-3'}>
                  {rowData.row.customer.fullName
                    ? `${rowData.row.customer.fullName.firstName} ${rowData.row.customer.fullName.lastName}`
                    : '-'}
                </div>
              </Grid>
            </Grid>
          </div>
        </>
      );
    },
  };
};
